module.exports = __webpack_public_path__ + "img/about-advantage1.6fe2d0f9.png";